module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAMFBMVEXvKQD//wD3IQD3KQD3UgD3YwDvIQD3WgD/9wD1pQD/7wD/3gD7tQD31gD3awDvSgBgWfT/AAAA9ElEQVRIx+3UT2oCMRzF8adplXaVNyIttItYoZtuYltwJf65gXgBwRN4BD2BeAKP4lE8igQmgqvkgQvBfBbDLOZLZpIfA4f71kT0Z+X2IzcZxRszp89LepO4CvfITA71zcrvMpONhYr6PtGqY/CsrdJg9JmbmEvTQi5XFzZ+2GyRSr7+GVQGNW6R8r0OST8OSptv6TcbXi3SnhokDUi+O0SvLnOfIZmzM6U4Ll2AHalhONBqKRRPVbhaHxf16eSlH+ZmfHlSHWrjB78QNUiv/tFYOYi6W7Vo+ZPHY2oavTlCP/mJmvQI1Y+FzOnJEkVRFMVNnAHdNxSE8kDWLAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/images/language/cn.png
// module id = 498
// module chunks = 0